import ServerApi from './$server.api'

export default {
    login,
    signup,
    getUsers,
    updateUser,
    updateUserEmail,
    updateUserPassword,
    verifyToken
}

async function login(data) {
    return await ServerApi.request('post', '/users/login', {data})
}

async function signup(data) {
    return await ServerApi.request('post', '/users/signup', {data})
}

async function getUsers(query) {
    return await ServerApi.request('get', '/users', {query})
}

async function updateUser(userId, data) {
    return await ServerApi.request('put', `/users/${ userId }`, {data})
}

async function updateUserEmail(userId, data) {
    return await ServerApi.request('put', `/users/${ userId }/email`, {data})
}

async function updateUserPassword(userId, data) {
    return await ServerApi.request('put', `/users/${ userId }/password`, {data})
}

async function verifyToken(token) {
    return await ServerApi.request('get', `/sessions/token/${ token }`)
}